// @flow

import React from "react";
import { localize } from "redux-i18n";

import sharedActionCreators from "@modules/shared/actionCreator";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import actionCreators from "@modules/service/actionCreator";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyAssignment } from "@modules/service/types";
import type { StepProps } from "@components";

type OwnProps = $Exact<{
  hierarchy: ?HierarchyTree,
  assignments: Array<HierarchyAssignment>,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step2Assignments extends React.Component<Props> {
  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.props.onChange({ assignments: data });
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <div className="w-100 px-0 mx-0">
        {this.props.hierarchy ? (
          <HierarchyScopeForm
            hierarchy={this.props.hierarchy}
            assignments={this.props.assignments || []}
            onChange={this.handleChanges}
          />
        ) : null}
      </div>
    );
  }
}
export default localize()(Step2Assignments);
